<template>
  <div class="student-preference-centre-sections">
    <div
      v-for="row in sectionsContent"
      :key="row.id"
      class="Section PrefContent-introText"
    >
      <h2>{{ row.custom_name }}</h2>
      <div class="Notice Notice--info">
        <p class="Notice-copy">
          {{ copy.notice }}<br>{{ copy.notice_update }}
        </p>
      </div>
      <div class="Form-field">
        <textarea
          id="custom_content"
          v-model="row.custom_content"
          name="custom_content"
          cols="30"
          rows="10"
          class="Form-textarea"
          placeholder="Enter introduction text"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CommonOperations from '../../../mixins/common-operations';
import LocalCopy from '../../../lang/en.json';

export default {
  mixins: [CommonOperations],
  props: {
    sectionsData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      sectionsContent: [],
    };
  },
  computed: {
    copy() {
      return LocalCopy.studentPreferenceCenter.subscribedSections;
    },
  },
  created() {
    this.formatData(this.sectionsData);
    this.$bus.$on('updateDataAfterReset', (event) => {
      this.formatData(event.sectionsData);
    });
  },
  methods: {
    formatData(data) {
      this.sectionsContent = data;
    },
  },
};
</script>
